require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-celebrity-brands-using-shopify.json") })
        }
      }, "path---blog-celebrity-brands-using-shopify");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-celebrity-brands-using-shopify!./.cache/json/blog-celebrity-brands-using-shopify.json
// module id = 430
// module chunks = 231608221292675